import { Component, OnInit } from '@angular/core';
import { Social_interface } from '../../../domain/entites/footer-themes.model';
import { FooterFacade } from '../../../domain/facates/footer-themes.facades';

@Component({
  selector: 'app-footer-three',
  templateUrl: './footer-three.component.html',
  styleUrls: ['./footer-three.component.css']
})
export class FooterThreeComponent implements OnInit {


  socials : Social_interface[] = [];

  stores = {
    app_store: '',
    play_store: ''
  };


  constructor(
    private facade: FooterFacade
  ) { }

  ngOnInit(): void 
  {

    // get website attributes
    this.get_web_attributes();

    
    // get socials
    this.get_socials();
  
  }



  get_socials()
  {
    
    this.facade.get_socials();

    this.facade.socials_selector$.subscribe(
      (state)=>{
        this.socials = state;
      },
      (err)=>{
        console.error(err);
      }
    );

  }


  get_web_attributes()
  {

    this.facade.get_site_theme();
    

    this.facade.site_theme_selector$.subscribe(
      (state)=>{
        
        this.stores.play_store = state['google_play'];
        this.stores.app_store = state['app_store'];
      
      }
    );
  

  }


}
